// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#LockIcon path.a{fill:#0a1343}`, "",{"version":3,"sources":["webpack://./src/packages/lawyers/components/LockModal/LockModal.scss"],"names":[],"mappings":"AACE,iBACE,YAAA","sourcesContent":["#LockIcon {\n  path.a {\n    fill: #0a1343;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
